import { use_slice_generation } from '@/hooks/store/use_slices';
import { DTO_TREE__generations } from '@shared/dto/generation/tree/DTO_TREE__generations';
import { useMemo } from 'react';

export function HOOK__user_task_generations_tree() {
  /*
   * STORE
   */
  const { user_task_current } = use_slice_generation(['generations_map', 'user_task_current']);

  const generations_tree = useMemo(() => get_generations_tree(), [user_task_current]);

  /*
   * EFFECTS
   */

  function get_generations_tree() {
    if (user_task_current.is_stub()) return DTO_TREE__generations.CREATE_STUB();
    if (!user_task_current.are_generations_loaded) return DTO_TREE__generations.CREATE_STUB();

    let out = DTO_TREE__generations.create(user_task_current.generations);

    return out;
  }

  return { generations_tree };
}
